import React from 'react';

interface Props {
    className?: string,
    label: string,
}
const PaneMenuGroup: React.FC<Props> = ({
    label,
    className = "",
    children,
}) => {
    let classNames: Array<string> = [
        'ct-pane-menu__group',
        className
    ];

    return (
        <div className={classNames.join(' ')} >
            <div className='ct-pane-menu__item ct-pane-menu__header'>
                {label}
            </div>
            {children}
        </div>
    );
}

export default PaneMenuGroup;
